<template>
    <div class="ob1-rating" :style="ob1RatingStyle" :title="title">
        <span class="ob1-stars" :data-rating="roundedAverage" aria-hidden="true" />
        <component
            :is="link && text ? 'a' : 'span'"
            :href="link || undefined"
            @click="link ? clickHandler($event) : null"
        >
            <span class="ob1-score" :style="ob1ScoreStyle"><span class="visually-hidden">Note </span>{{ formattedAverage }}</span><span class="ob1-score-max">/5</span>
            <span class="ob1-rating-label">{{ text }}</span>
        </component>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: 'Rating',
    props: {
        average: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            default: null
        },
        link: {
            type: String,
            default: null
        },
        // taille de police en rem
        ratingResultsHeight: {
            type: Number,
            required: true
        },
        // taille de police note en rem
        fontSize: {
            type: Number,
            required: false,
            default: null
        }
    },
    computed: {
        roundedAverage() {
            if (Math.round(this.average) === this.average) {
                return this.average
            }
            return this.average.toFixed(1)
        },
        formattedAverage() {
            return this.roundedAverage.toString().replace('.', ',')
        },
        ob1RatingStyle() {
            return '--rating-results-height: ' + this.ratingResultsHeight + 'rem;'
        },
        ob1ScoreStyle() {
            return this.fontSize ? 'font-size: ' + this.fontSize + 'rem;' : ''
        },
        title() {
            if (this.withScore) return null;
            else return this.roundedAverage + ' sur 5';
        }
    },
    methods: {
        clickHandler(event: Event) {
            this.$emit('ob1-rating-link', event);
        }
    }
});
</script>
